import { Component, ChangeDetectionStrategy, OnInit, ChangeDetectorRef, PLATFORM_ID, Inject } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BookDemoModalComponent } from '../book-demo-modal/book-demo-modal.component';

@Component({
  selector: 'app-recruiter-hero',
  standalone: true,
  imports: [CommonModule, RouterModule, BookDemoModalComponent],
  templateUrl: './recruiter-hero.component.html',
  styleUrls: ['./recruiter-hero.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RecruiterHeroComponent implements OnInit {
  stats = {
    candidatesEval: 0,
    companies: 0,
    hiringAccuracy: 0,
    fasterHiring: 0,
    applied: 0,
    screened: 0,
    assessed: 0,
    interviewed: 0,
    hired: 0
  };

  isDemoModalOpen = false;
  selectedModalOption: 'demo' | 'quote' = 'demo';

  private targets = {
    candidatesEval: 15,
    companies: 500,
    hiringAccuracy: 98,
    fasterHiring: 2,
    applied: 1240,
    screened: 640,
    assessed: 310,
    interviewed: 120,
    hired: 38
  };

  constructor(
    private cdr: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.animateStats();
    } else {
      this.stats = { ...this.targets };
    }
  }

  openDemoModal(option: 'demo' | 'quote' = 'demo') {
    this.selectedModalOption = option;
    this.isDemoModalOpen = true;
    this.cdr.markForCheck();
  }

  closeDemoModal() {
    this.isDemoModalOpen = false;
    this.cdr.markForCheck();
  }

  private animateStats() {
    const duration = 2000;
    const frameRate = 16;
    const totalFrames = Math.round(duration / frameRate);

    let currentFrame = 0;

    const timer = setInterval(() => {
      currentFrame++;
      const progress = currentFrame / totalFrames;

      // Easing function (easeOutExpo)
      const ease = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);

      for (const key of Object.keys(this.targets) as Array<keyof typeof this.targets>) {
        this.stats[key] = Math.floor(this.targets[key] * ease);
      }

      this.cdr.markForCheck();

      if (currentFrame >= totalFrames) {
        clearInterval(timer);
        this.stats = { ...this.targets };
        this.cdr.markForCheck();
      }
    }, frameRate);
  }
}
